import React from 'react';

import { useLocation } from 'react-router-dom';
import { defineMessages, useIntl } from 'react-intl';
import {
  getBlocksFieldname,
  getBlocksLayoutFieldname,
  getBaseUrl,
} from '@plone/volto/helpers';
import config from '@plone/registry';

const messages = defineMessages({
  unknownBlock: {
    id: 'Unknown Block',
    defaultMessage: 'Unknown Block {block}',
  },
});

const ViewBlocks = ({ content, exclude = ['title', 'description'] }) => {
  const intl = useIntl();
  const location = useLocation();
  const blocksFieldname = getBlocksFieldname(content);
  const blocksLayoutFieldname = getBlocksLayoutFieldname(content);

  const items =
    content[blocksLayoutFieldname]?.items?.length > 0
      ? content[blocksLayoutFieldname].items.filter((block) => {
          const blockType = content[blocksFieldname]?.[block]?.['@type'];
          return exclude.indexOf(blockType) < 0;
        })
      : null;

  //è il caso in cui c'è solo il primo blocco di testo vuoto. Non si vuole renderizzare il <br/>a

  if (items?.length === 1) {
    const block = content[blocksFieldname][items[0]];

    if (block['@type'] === 'slate' && !block.text) {
      if (block?.value?.[0]?.children?.[0]?.text === '') return null;
    }
  }

  return items?.length > 0 ? (
    <>
      {items.map((block) => {
        const blockType = content[blocksFieldname]?.[block]?.['@type'];
        const Block = config.blocks.blocksConfig[blockType]?.['view'] || null;
        if (Block != null) {
          return (
            <Block
              key={block}
              id={block}
              properties={content}
              data={content[blocksFieldname][block]}
              path={getBaseUrl(location?.pathname || '')}
            />
          );
        } else {
          return (
            <div key={block}>
              {intl.formatMessage(messages.unknownBlock, {
                block: content[blocksFieldname]?.[block]?.['@type'],
              })}
            </div>
          );
        }
      })}
    </>
  ) : null;
};

export default ViewBlocks;
